import { QueryClient } from "@tanstack/react-query";

// Shared QueryClient instance - used by both App.tsx and api.ts interceptors
// This allows the auth interceptor to clear/invalidate cache on auth events
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // Данные устаревают через 30 секунд
      gcTime: 1000 * 60 * 30,
      retry: (failureCount, error) => {
        // Don't retry on 401/403
        if (error && typeof error === 'object' && 'response' in error) {
          const axiosError = error as { response?: { status?: number } };
          if (axiosError.response?.status === 401 || axiosError.response?.status === 403) {
            return false;
          }
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: true, // Обновлять при возврате на вкладку
      refetchOnMount: true, // Обновлять при монтировании компонента
    },
  },
});
